import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import { OutputDataUrl } from './OutputDataUrl';
import { CancelErrorsOutputDataType } from '../schema/types';

const deleteCancelErrorsOutputData = async (
  request: CancelErrorsOutputDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .delete<void>(
      expand(OutputDataUrl.OUTPUT_DATA_CALCULATION_ERRORS, request),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useCancelErrorsOutputData = createApiMutationHook(
  ['cancelErrorsOutputData'],
  getMutationFn(deleteCancelErrorsOutputData),
);
